// extracted by mini-css-extract-plugin
module.exports = {"section":"Compare_section__r1d9m"};